<div class="user-list">
    <div class="buttons">
        <div class="add-new-button">
            <app-button
                [buttonType]="'secondary'"
                [leftIcon]="'plus'"
                [label]="'userList.button.new' | translate"
                (clickEmitter)="openUploadUserDialog($event)"
            ></app-button>
        </div>
        <div class="blocked">
            <mat-checkbox
                (change)="getUsers($event.checked)"
                [color]="'primary'"
                [labelPosition]="'before'"
            >
                {{ "userList.blocked" | translate }}
            </mat-checkbox>
        </div>
    </div>
    <table mat-table [dataSource]="currentUserItems" class="mat-elevation-z0" matSort
           (matSortChange)="sortChange($event)">
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "userList.column.id" | translate }}</th>
            <td mat-cell *matCellDef="let user"> {{ user.id }}</td>
        </ng-container>

        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "userList.column.email" | translate }}</th>
            <td mat-cell *matCellDef="let user"> {{ user.email }}</td>
        </ng-container>

        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>{{ "userList.column.action" | translate }}</th>
            <td mat-cell *matCellDef="let user">
                @if (canEditUsers$ | async) {
                    <div
                        class="container">
                        <button mat-button
                                class="table-button"
                                [matTooltip]="'buttons.edit' | translate"
                                (click)="openEditDialog(user)">
                            <mat-icon class="icon">edit</mat-icon>
                        </button>
                    </div>
                }
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>

    <div>
        <p>{{ 'userList.resultCount' | translate : {count: count} }}</p>
        <button [disabled]="currentPage <= 0" (click)="paginate(currentPage - 1)">Vorige</button>
        <button [disabled]="!hasNextPage" (click)="paginate(currentPage + 1)">Volgende</button>
        <select [ngModel]="pageSize" (ngModelChange)="setPageSize($event)">
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="25">25</option>
        </select>
    </div>
</div>
